import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableCategory = QueryHookResult<
  typeof useCategoriesQuery
>[number];

export const useCategoriesQuery = createQueryHook(
  'shared.selectCategory',
  (params: { ids?: string[]; searchTerm?: string }) => ({
    categories: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: 50,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        description: true,
      },
    },
  }),
  {
    select: (data) => data?.categories.entries ?? [],
  },
);

export const SelectCategory = createEntityComboBox.remotelySearched(
  'SelectCategory',
  useCategoriesQuery,
  {
    formatLabel: (entity) => entity.name,
    formatSubLabel: (entity) => entity.description || '',
    compactSelection: true,
  },
);
